import db from './../db';

export default {
    get: function(url) {
        return new Promise(function (resolve, reject) {
            resolve({
                body: {
                    email: 'john@test.com',
                    name: 'John',
                    userId: 99,
                    timezone: db.timezone,
                    culture: db.culture
                }
            });
        });
    }
};



// WEBPACK FOOTER //
// ./test/data/account/get.js